import { baseApi } from "../../../api/baseApi.js";
import { getQueryParams, prepareQueryParams } from "../../../helpers/index.js";

const { co, dealId } = getQueryParams();

export const offerApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getOffer: build.query({
      query: (extraParams = {}) => {
        const params = prepareQueryParams(extraParams);
        return {
          url: "/reservation",
          method: "GET",
          params,
        };
      },
      providesTags: ["Offer"],
    }),
    getVRMData: build.query({
      query: () => {
        return {
          url: `/customers/${co}`,
          method: "GET",
        };
      },
    }),
    addRebookCredit: build.mutation({
      query: (quotenumber) => {
        return {
          url: `/customers/${co}/rebook`,
          method: "POST",
          body: {
            quotenumber,
            dealId,
          },
        };
      },
    }),
  }),
});

export const {
  useGetOfferQuery,
  useLazyGetOfferQuery,
  useGetVRMDataQuery,
  useAddRebookCreditMutation,
} = offerApi;
